// Shared base64 → blob: object URL decoder. Used for audio + doodle preview URLs
// across runGeneration, StudioCreate, and Player (single source of truth, DRY).
export function base64ToObjectUrl(b64: string, mimeType: string): string {
  const bytes = atob(b64);
  const buf = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) buf[i] = bytes.charCodeAt(i);
  return URL.createObjectURL(new Blob([buf], { type: mimeType }));
}
